module.exports = __webpack_public_path__ + "static/media/zoomy3.c5253e6e.jpg";